"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-0cfcfc8e"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { class: "flex-column registration-form-container" };
const _hoisted_2 = { class: "registration-data-subtitle" };
const _hoisted_3 = { class: "feature-grid" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = { class: "feature-inner" };
const _hoisted_6 = { class: "feature-label" };
const _hoisted_7 = { class: "feature-tooltip" };
const _hoisted_8 = { class: "font-sm" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "feature-divider" }, null, -1 /* HOISTED */));
const _hoisted_10 = { class: "tooltip-body" };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "tooltip-arrow" }, null, -1 /* HOISTED */));
const vue_3 = require("vue");
const PtoIcon_vue_1 = __importDefault(require("../../../assets/icons/PtoIcon.vue"));
const AutoIcon_vue_1 = __importDefault(require("../../../assets/icons/AutoIcon.vue"));
const OplusChatIcon_vue_1 = __importDefault(require("../../../assets/icons/OplusChatIcon.vue"));
const OplusLogoIcon_vue_1 = __importDefault(require("../../../assets/icons/OplusLogoIcon.vue"));
const TimecardAppIcon_vue_1 = __importDefault(require("../../../assets/icons/TimecardAppIcon.vue"));
const registration_1 = require("../model/registration");
const provider_1 = require("../../../../provider/provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'RegistrationData',
    setup(__props) {
        const viewModel = (0, vue_3.inject)(provider_1.registrationViewModelInjectKey);
        const userViewModel = (0, vue_3.inject)(provider_1.userRegistrationViewModelInjectKey);
        const presenter = (0, vue_3.inject)(provider_1.groupRegistrationPresenterInjectKey);
        const features = [
            {
                id: registration_1.FeatureCode.PRO,
                label: 'シフト管理',
                tooltip: 'スマホで提出したシフトは管理画面に自動反映。希望シフト回収、作成、スタッフへの共有までカンタン操作！',
                icon: OplusLogoIcon_vue_1.default,
            },
            {
                id: registration_1.FeatureCode.TIME,
                label: '勤怠管理',
                tooltip: 'WEB打刻やQRコード打刻など、業種や業態に合わせた打刻方法を提供。シフトと勤怠の一元管理を実現。',
                icon: TimecardAppIcon_vue_1.default,
                iconClass: 'feature-icon-time',
            },
            {
                id: registration_1.FeatureCode.PTO,
                label: '有休管理',
                tooltip: '有休申請から承認までシンプルに行なえ、スタッフごとの取得状況も手軽に管理。',
                icon: PtoIcon_vue_1.default,
            },
            {
                id: registration_1.FeatureCode.AUTO,
                label: '自動シフト作成',
                tooltip: '条件を設定して自動作成ボタンをワンクリックするだけでシフト作成！貴社にあったロジック設定や段階的割当も可能。',
                icon: AutoIcon_vue_1.default,
                iconClass: 'feature-icon-auto',
            },
            {
                id: registration_1.FeatureCode.CHAT,
                label: 'oplus chat',
                tooltip: '業務連絡も日々のコミュニケーションも一元化。個人SNSに頼らず、スムーズな情報共有とチーム連携を実現。',
                icon: OplusChatIcon_vue_1.default,
                iconClass: 'feature-icon-chat',
            },
        ];
        const selectedFeatures = (0, vue_3.computed)(() => {
            return viewModel?.value.selectedFeatures || [];
        });
        function toggleSelected(id) {
            // PRO (shift) can't be unselected
            if (id === registration_1.FeatureCode.PRO) {
                return;
            }
            presenter?.toggleSelectedFeature(id);
        }
        function isActive(id) {
            return selectedFeatures.value.includes(id);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(userViewModel)?.form.name) + "様, 他の機能やサービスにもご興味はありますか？", 1 /* TEXT */),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(features, (f) => {
                        return (0, vue_2.createElementVNode)("button", {
                            key: f.id,
                            class: (0, vue_2.normalizeClass)(["feature-card", { active: isActive(f.id) }]),
                            onClick: ($event) => (toggleSelected(f.id))
                        }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                (f.icon)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)((0, vue_2.resolveDynamicComponent)(f.icon), {
                                        key: 0,
                                        class: (0, vue_2.normalizeClass)([f.iconClass, "feature-icon"])
                                    }, null, 8 /* PROPS */, ["class"]))
                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)(f.label), 1 /* TEXT */)
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)(f.label), 1 /* TEXT */),
                                _hoisted_9,
                                (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)(f.tooltip), 1 /* TEXT */),
                                _hoisted_11
                            ])
                        ], 10 /* CLASS, PROPS */, _hoisted_4);
                    }), 64 /* STABLE_FRAGMENT */))
                ])
            ]));
        };
    }
});
